/** Defaults let older backups and editor samples remain readable after catalog upgrades. */
export function disciplineMetadata(value: object) {
  const row = value as {
    organisationId?: string | null;
    displayOrder?: number;
  };
  return {
    organisationId: row.organisationId ?? undefined,
    displayOrder: row.displayOrder ?? 0,
  };
}
export function ageCategoryMetadata(value: object) {
  const row = value as {
    sex?: string | null;
    isSenior?: boolean;
    isOpen?: boolean;
    isHandisport?: boolean;
    priority?: number;
  };
  return {
    ...disciplineMetadata(value),
    sex: row.sex ?? null,
    isSenior: row.isSenior ?? false,
    isOpen: row.isOpen ?? false,
    isHandisport: row.isHandisport ?? false,
    priority: row.priority ?? 0,
  };
}
export function weightCategoryMetadata(value: object) {
  const row = value as {
    disciplineId?: number;
    ageCategoryId?: number | null;
    isHandisport?: boolean;
    isOpen?: boolean;
    minInclusive?: boolean;
    maxInclusive?: boolean;
  };
  return {
    ...disciplineMetadata(value),
    disciplineId: row.disciplineId ?? 1,
    ageCategoryId: row.ageCategoryId ?? null,
    isHandisport: row.isHandisport ?? false,
    isOpen: row.isOpen ?? false,
    minInclusive: row.minInclusive ?? false,
    maxInclusive: row.maxInclusive ?? true,
  };
}
